





import Vue from 'vue';
import Component from 'vue-class-component';

@Component({})
export default class Register extends Vue {
  public get message() {
    return `Anmeldung fehlgeschlagen: 
    Wir konnten Sie leider nicht anmelden. Bitte kontaktieren Sie die SESAM-Hotline unter: 0711 4909-6358 oder per E-Mail: sesam@lmz-bw.de.`;
  }
}
